// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"style_customMenu__KEu7q","popoverCustom":"style_popoverCustom__Ob8rS","selectedItem":"style_selectedItem__Ler1h","caretSpan":"style_caretSpan__I7Ect"};